import React, { useEffect, useRef, useState } from 'react';
import { Collection, ChevronLeft, ChevronRight } from 'react-bootstrap-icons';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { SearchIcon } from '@react-pdf-viewer/search';
import { Worker, Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { MoreActionsPopover } from '@react-pdf-viewer/toolbar';
import { SelectionMode } from '@react-pdf-viewer/selection-mode';
import es_ES from '@react-pdf-viewer/locales/lib/es_ES.json';
import GLIFOSSearchSidebar from './GLIFOSSearchSidebar';
import CollectionListViewer from '../components/CollectionListViewer';
//import { selectionModePlugin } from '@react-pdf-viewer/selection-mode';

// Import styles
import '@react-pdf-viewer/zoom/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import '@react-pdf-viewer/core/lib/styles/index.css';
const renderTooltip = (props) => (
	<Tooltip id='button-tooltip' {...props}>
		{props?.text}
	</Tooltip>
);
export default function GLIFOSPdfViewer(props) {
	const { file, itemInfo, apiService, isadg, images } = props;
	const [collection, setCollection] = useState({
		isLoading: true,
		payload: {},
	});
	const navigate = useNavigate();

	const prevImage = () => {
		if (itemInfo?.prevSibling)
			navigate(`/glifos/item/${itemInfo.prevSibling}`);
	};
	const nextImage = () => {
		if (itemInfo?.nextSibling)
			navigate(`/glifos/item/${itemInfo.nextSibling}`);
	};

	const openCollection = () => {
		document.getElementById('collections-list').classList.toggle('show');
		document
			.getElementById('collections-list-info')
			.classList.toggle('show');
	};

	useEffect(() => {
		try {
			if (!itemInfo?.ancestors?.root) return;
			if (collection.isLoading)
				apiService.getCollection(
					{},
					{ isadg: itemInfo.ancestors.root },
					(_, rdata) => {
						setCollection({ isLoading: false, payload: rdata });
						//console.log('loaded', rdata);
					}
				);
		} catch (e) {
			//console.log(e);
			setCollection((prevCollection) => ({
				...prevCollection,
				isLoading: false,
			}));
		}
		return () => {
			setCollection((prevCollection) => ({
				...prevCollection,
				isLoading: false,
			}));
		};
	}, [apiService, itemInfo, collection.isLoading]);

	const renderToolbar = (Toolbar) => (
		<Toolbar>
			{(slots) => {
				const {
					CurrentPageInput,
					EnterFullScreen,
					GoToNextPage,
					GoToPreviousPage,
					NumberOfPages,
					Rotate,
					SwitchTheme,
					Zoom,
					ZoomIn,
					ZoomOut,
				} = slots;
				const moreActions = {
					...slots,
					PrintMenuItem: () => <></>,
					OpenMenuItem: () => <></>,
					DownloadMenuItem: () => <></>,
					SwitchSelectionModeMenuItem: () => <></>,
					SwitchSelectionMode: () => <></>,
				};
				return (
					<div
						data-testid='toolbar'
						className='rpv-toolbar'
						role='toolbar'
						aria-orientation='horizontal'
					>
						<div className='rpv-toolbar__left'>
							<div className='rpv-toolbar__item'>
								<GoToPreviousPage />
							</div>
							<div className='rpv-toolbar__item'>
								<CurrentPageInput />
								<span className='rpv-toolbar__label'>
									{' / '}
									<NumberOfPages />
								</span>
							</div>
							<div className='rpv-toolbar__item'>
								<GoToNextPage />
							</div>
						</div>
						<div className='rpv-toolbar__center'>
							{itemInfo?.prevSibling && (
								<div className='rpv-toolbar__item'>
									<OverlayTrigger
										placement='bottom'
										delay={{
											show: 0,
											hide: 0,
										}}
										overlay={(props) =>
											renderTooltip({
												...props,
												text: 'Anterior',
												className:
													'rpv-core__tooltip-body',
											})
										}
									>
										<div
											ria-describedby='rpv-core__tooltip-body-prev-sibling'
											onClick={prevImage}
										>
											<button
												aria-label='Anterior'
												aria-keyshortcuts='Ctrl+LeftArrow'
												className='rpv-core__minimal-button'
												type='button'
												data-testid='prev__sibling-button'
											>
												<ChevronLeft />
											</button>
										</div>
									</OverlayTrigger>
								</div>
							)}
							<div className='rpv-toolbar__item'>
								<ZoomOut />
							</div>
							<div className='rpv-toolbar__item'>
								<Zoom />
							</div>
							<div className='rpv-toolbar__item'>
								<ZoomIn />
							</div>
							{itemInfo?.nextSibling && (
								<div className='rpv-toolbar__item'>
									<OverlayTrigger
										placement='bottom'
										delay={{
											show: 0,
											hide: 0,
										}}
										overlay={(props) =>
											renderTooltip({
												...props,
												text: 'Siguiente',
												className:
													'rpv-core__tooltip-body',
											})
										}
									>
										<div
											ria-describedby='rpv-core__tooltip-body-next-sibling'
											onClick={nextImage}
										>
											<button
												aria-label='Siguiente'
												aria-keyshortcuts='Ctrl+LeftArrow'
												className='rpv-core__minimal-button'
												type='button'
												data-testid='next__sibling-button'
											>
												<ChevronRight />
											</button>
										</div>
									</OverlayTrigger>
								</div>
							)}
						</div>
						<div className='rpv-toolbar__right'>
							<div className='rpv-toolbar__item d-none d-md-flex'>
								<SwitchTheme />
							</div>
							<div className='rpv-toolbar__item'>
								<EnterFullScreen />
							</div>
							<div className='rpv-toolbar__item'>
								{itemInfo?.ancestors?.root && (
									<div className='rpv-toolbar__item'>
										<OverlayTrigger
											placement='bottom'
											delay={{
												show: 0,
												hide: 0,
											}}
											overlay={(props) =>
												renderTooltip({
													...props,
													text: 'Colección',
													className:
														'rpv-core__tooltip-body',
												})
											}
										>
											<div
												ria-describedby='rpv-core__tooltip-body-collection'
												onClick={openCollection}
											>
												<button
													aria-label='Colección'
													aria-keyshortcuts='Ctrl++'
													className='rpv-core__minimal-button'
													type='button'
													data-testid='collection-button'
												>
													<Collection />
												</button>
											</div>
										</OverlayTrigger>
									</div>
								)}
								{!itemInfo?.ancestors?.root && <Rotate />}
							</div>
							<div className='rpv-toolbar__item'>
								<MoreActionsPopover toolbarSlot={moreActions} />
							</div>
						</div>
					</div>
				);
			}}
		</Toolbar>
	);
	const defaultLayoutPluginInstance = defaultLayoutPlugin({
		sidebarTabs: (defaultTabs) => [
			{
				content: (
					<GLIFOSSearchSidebar
						searchPluginInstance={
							defaultLayoutPluginInstance.toolbarPluginInstance
								.searchPluginInstance
						}
					/>
				),
				icon: <SearchIcon />,
				title: 'Buscar',
			},
			defaultTabs[0],
		],
		renderToolbar,
		toolbarPlugin: {
			selectionModePlugin: {
				selectionMode: SelectionMode.Hand,
			},
			zoomPlugin: {
				enableShortcuts: true,
			},
		},
	});
	const pdfRef = useRef(null);

	useEffect(() => {
		if (pdfRef.current) {
			console.log(pdfRef.current);
		}
	}, [file]);
	return (
		<div className='gpdfv'>
			<Worker workerUrl='https://unpkg.com/pdfjs-dist@2.15.349/build/pdf.worker.min.js'>
				<Viewer
					fileUrl={file}
					plugins={[defaultLayoutPluginInstance]}
					localization={es_ES}
					defaultScale={SpecialZoomLevel.PageWidth}
				/>
			</Worker>
			{isadg && (
				<CollectionListViewer
					collection={collection}
					apiService={apiService}
					isadg={isadg}
					img={images[0]}
				/>
			)}
		</div>
	);
}
